var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMedication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.667 52.9375H23.0626C20.8189 52.9375 19 51.1186 19 48.8749V25.8538C19 23.6102 20.8189 21.7913 23.0626 21.7913H40.667C42.9107 21.7913 44.7296 23.6102 44.7296 25.8538V48.8749C44.7295 51.1186 42.9107 52.9375 40.667 52.9375Z",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9739 17.7573H23.7562C23.0099 17.7573 22.4048 17.2531 22.4048 16.6311V12.1262C22.4048 11.5042 23.0099 11 23.7562 11H39.9738C40.7201 11 41.3252 11.5042 41.3252 12.1262V16.631C41.3253 17.2531 40.7202 17.7573 39.9739 17.7573Z",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1079 17.7573L24.4321 21.8117",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6221 17.7573L39.2978 21.8117",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4165 25.8538H44.7292",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25.8538H24.094",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48.8748H44.7294",
    stroke: "#010101",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5729 40.0727H37.9584C38.7063 40.0727 39.3126 39.4664 39.3126 38.7185V36.0101C39.3126 35.2621 38.7063 34.6559 37.9584 34.6559H34.5729V31.2704C34.5729 30.5225 33.9666 29.9163 33.2187 29.9163H30.5103C29.7625 29.9163 29.1562 30.5226 29.1562 31.2704V34.6559H25.7707C25.0228 34.6559 24.4165 35.2622 24.4165 36.0101V38.7185C24.4165 39.4664 25.0228 40.0727 25.7707 40.0727H29.1562V43.4581C29.1562 44.206 29.7625 44.8123 30.5103 44.8123H33.2187C33.9666 44.8123 34.5729 44.206 34.5729 43.4581V40.0727Z",
    stroke: "#EB731A",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.2,
    stroke: "black",
    strokeWidth: 1.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10L10 54",
    stroke: "#010101",
    strokeWidth: 1.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMedication);
export default __webpack_public_path__ + "static/media/no-medication.c6667540e68997dee85ac83cce2e26ef.svg";
export { ForwardRef as ReactComponent };